import {
  BlockLayoutType,
  ServerBlockTypeType,
  getServerBlockType
} from "@pathwright/blocks-core"
import { capitalize, find } from "lodash"

const deprecatedLayouts = [
  {
    blockType: "Video",
    layout: "center"
  },
  {
    blockType: "Embed",
    layout: "center"
  },
  {
    blockType: "Image",
    layout: "center"
  }
]

export const getBlockTypeLabel = ({
  type,
  blockTypes,
  layout
}: {
  type: string
  blockTypes: ServerBlockTypeType[]
  layout: string
}) => {
  const BT = getServerBlockType(type, blockTypes) as ServerBlockTypeType
  const BL = BT.layouts
    ? Object.values(BT.layouts).find((bl) => bl.key === layout)
    : null
  return BL ? BL.label : capitalize(type)
}

export const getBlockTypeLayoutOptions = ({
  type,
  blockTypes
}: {
  type: string
  blockTypes: ServerBlockTypeType[]
}) => {
  const BT = getServerBlockType(type, blockTypes) as ServerBlockTypeType
  return Object.values(BT.layouts || []).filter(({ key }) =>
    filterDeprecatedLayouts({ type: BT.type, layout: key })
  )
}

const filterDeprecatedLayouts = ({
  type,
  layout
}: {
  type: string
  layout: string
}) => {
  const found = find(
    deprecatedLayouts,
    (l) => l.blockType === type && l.layout === layout
  )
  return !found
}

export const filterDeprecatedMenuOption = ({
  blockType,
  layout
}: {
  blockType: string
  layout: string
}) => filterDeprecatedLayouts({ type: blockType, layout })

type MenuOption = {
  blockType: string
  data: Record<string, any>
  layout: string
  label: string
  menuCategory: string
  menuOrder: number
  previewImage: string
}

export const mapLayoutToMenuOption =
  (bt: ServerBlockTypeType) => (layout: BlockLayoutType) =>
    ({
      blockType: bt.type,
      data: layout.data,
      layout: layout.key,
      label: layout.label,
      menuCategory: layout.menuCategory || bt.menu?.category,
      menuOrder: layout.menuOrder || bt.menu?.order,
      previewImage: layout.previewImage || ""
    } as MenuOption)

export const addMovedLayoutsToMenu = (
  blockTypes: ServerBlockTypeType[],
  menuData: BlockLayoutType[]
) => {
  // const movedLayoutOptions = blockTypes.reduce((movedOptions, bt) => {
  //   const btLayouts = Object.values(bt.layouts || {})
  //   const btMoved = btLayouts.filter(({ menuCategory }) => !!menuCategory)
  //   const options = btMoved.map((layout) =>
  //     mapLayoutToMenuOption(bt)(layout)
  //   ) as MenuOption[]

  //   // const menuCategory = menuData[]

  //   return movedOptions.concat(options)
  // }, [] as MenuOption[])

  // console.log({ movedLayoutOptions, menuData })

  return menuData
}
